import {env} from "../../../../../res/config/env";
import axios from "axios";
import {api} from "../../../../../res/rest/api";
import {request} from "../../../../../res/rest/restRequest";
import MapUtil from "../../../../logic/collection/mapUtil";

const bannerFormRequest = () => {

    const builder = {};
    const data = {};
    const attachments = [];

    builder.setProductID = (pid) => {
        if(pid) {
            data.M_Product_ID = pid;
        }
        return builder;
    }

    builder.setStartDate = (date) => {
        data.StartDate = date;
        return builder;
    }

    builder.setEndDate = (date) => {
        data.EndDate = date;
        return builder;
    }

    builder.setProductCategoryID = (categoryID) => {
        data.M_Product_Category_ID = categoryID;
        return builder;
    }

    builder.setDescription = (description) => {
        data.Description = description;
        return builder;
    }

    builder.setProductIDList = (productRange) => {
        if(!productRange) return builder;

        const productIDList = MapUtil.mapToList(productRange, (k,v) => k);
        if(productIDList.length > 0) {
            data.x_product_ID_List = productIDList.join(",");
        }

        return builder;
    }

    builder.setBannerClickAction = (clickAction) => {
        data.x_banner_click_action = clickAction === "Go to product page" ? "G" : "R";
        return builder;
    }

    builder.setBannerType = (type) => {
        data.x_banner_form_type = type;
        return builder;
    }

    builder.addAttachment = (attachment) => {
        attachments.push(attachment);
        return builder;
    }

    const createBannerForm = async (session) => {
        const req = request.model("vendor_banner_form");
        const url = req.buildRequest(env.API_URL);

        const resp = await axios.post(url, data, api.auth(session));
        return resp.data;
    }

    const attachFile = async (session, id, name, data) => {
        const reqData = {name, data};
        const req = request.model("vendor_banner_form")
            .id(id)
            .attachment(true);

        console.log("here", req.buildRequest(""));

        const url = req.buildRequest(env.API_URL);
        const resp = await axios.post(url, reqData, api.auth(session));
        return resp;
    }

    // const createForm = () => {
    //
    // }

    builder.sendIt = async (session) => {
        if(session?.bPartnerID) {
            data.C_BPartner_ID = session.bPartnerID;
        }

        const res = await createBannerForm(session);
        const id = res.id;
        const attachmentUpload = attachments.map(a => attachFile(session, id, a.name, a.data));
        await void Promise.all(attachmentUpload);

        return "done";
    }

    return builder;
}

export default bannerFormRequest;